var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "mb-10 text-center" }, [
    _c("h2", { staticClass: "mt-5" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.$store.state.data.Steps[
              _vm.$store.state.activeStep
            ].Title.replace("${name}", _vm.$store.state.userInputs.FirstName__c)
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "text-editor text-base md:text-xl",
      domProps: {
        innerHTML: _vm._s(
          _vm.$store.state.data.Steps[_vm.$store.state.activeStep]
            .ThankYouMessageBeforeImage
        )
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "rounded-full flex items-center justify-center mx-auto my-4"
      },
      [
        _c("img", {
          staticClass: "flex-shrink-0 max-h-full max-w-full",
          attrs: {
            src:
              _vm.$store.state.data.Steps[_vm.$store.state.activeStep]
                .ThankYouImageUrl
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "mb-5 text-base md:text-xl",
      domProps: {
        innerHTML: _vm._s(
          _vm.$store.state.data.Steps[
            _vm.$store.state.activeStep
          ].ThankYouMessageAfterImage.replace(
            "${emailAddress}",
            "\n <div></div><strong>" +
              _vm.$store.state.userInputs.Email__c +
              "</strong>"
          )
        )
      }
    }),
    _vm._v(" "),
    _c("p", [
      _c(
        "a",
        {
          staticClass:
            "inline-block text-lg md:text-xl text-velux-blue underline hover:no-underline",
          attrs: {
            href:
              _vm.$store.state.data.Steps[_vm.$store.state.activeStep]
                .ButtonLinkUrl
          },
          on: {
            click: function($event) {
              return _vm.trackGoHome()
            }
          }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$store.state.data.Steps[_vm.$store.state.activeStep]
                  .ButtonLinkText
              ) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }